<template>
  <div>
    <div class="container">
      <div class="space-100"></div>
      <div class="row justify-content-center row-height">
        <div class="text-center">
          <div>
            <h2><strong>Login</strong></h2>
          </div>
          <div>
            <p>Bienvenido de vuelta. Inicia sesión para acceder a tu cuenta<br>
              <strong>¿Aún no tienes cuenta?<n-button style="color:#FF7C00; font-weight: bold; margin: 0px;" type="neutral" @click="modals.classic = true">Registrate</n-button></strong>
              <!-- REGISTRO DE CUENTA -->
              <modal :show-close="true" :show.sync="modals.classic" modal-classes="modal-lg" header-classes="justify-content-center">
                <h4 slot="header" class="title title-up text-color-blue"><strong>Registra tu cuenta Loyalty Refunds</strong></h4>
                <registro></registro>
              </modal>
              <!--FIN REGISTRO DE CUENTA -->
            </p>
          </div>
          <div>
            <form @submit="checkForm">
              <div>
                <input id="account" v-model="account" type="text" name="account" class="email-input" placeholder="Correo electrónico / Telefono"/>
                <br>
                <input id="password" v-model="password" type="password" name="password" min="0" class="password-input" placeholder="Contraseña"/>
              </div>
              <div>
                <div style="color: #FF6E6E; font-weight: bold; margin: 10px">{{ errors }}</div>
                <p>
                  <input class="input-button" type="submit" value="Iniciar sesión">
                </p>
              </div>
            </form>
            <!-- <div>
                <button class="recover-password-button" v-popover:popovertrigger type="">
                  <h6>¿Olvidaste tu contraseña?</h6>
                </button>
              </div> -->
              <div>
                <popover ref="popovertrigger" trigger="click" popper-class="popover text-center" placement="bottom">
                  <img src="../assets/assets_loyalty/alerta.png" alt="">
                  <div class="popover-body">Tu contraseña es la clave de tu tarjeta o tu codigo postal</div>
                </popover>
              </div>
          </div>
        </div>
      </div>
      <div class="space-100"></div>
      <div class="space-100"></div>

    </div>
    <main-footer></main-footer>
  </div>
</template>
<script>
import { Card, Button, FormGroupInput, Modal,  Alert} from '@/components';
import MainFooter from '@/layout/MainFooter';
import moment from 'moment';
import LoginService from '../service/core/login.service'
import {DatePicker, Popover} from 'element-ui'
import VueRecaptcha from 'vue-recaptcha';
import Registro from './components/Registro';

export default {
  name: 'login-page',
  data() {
    return {
      modals: {
        classic: false,
      },
      errors: '',
      correct: '',
      //Login
      account: null,
      password: null,
      loginService: new LoginService(),
    };
  },
  bodyClass: 'login-page',
  components: {
    Registro,
    Card,
    Alert,
    MainFooter,
    Modal,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [DatePicker.name]: DatePicker,
    VueRecaptcha,
    Popover
  },
  methods:{
    checkForm(e) {
      var account_element = document.getElementById('account');
      var password_element = document.getElementById('password');

      if (!this.account && !this.password){
        this.errors = 'Por favor, llena todos los campos';
        account_element.classList.add("has-danger");
        password_element.classList.add("has-danger");
      }else if (this.account && this.password) {
        this.errors = '';
        account_element.classList.add("correct2");
        password_element.classList.add("correct2");
        // return true
      }
      
      // 09030 gomez_andresf@hotmail.com
      const userData = {
        "login":{
          "account": this.account,
          "password": this.password
        }
      }

      e.preventDefault();
      this.loginService.login(userData).then(data => {
        location.href="/PerfilUsuario";
        sessionStorage.setItem('accountTk', data.data.results);
      }, error => {
        this.errors = "Contraseña y/o Usiario son incorrectos"
      })
    },
    checkForm2(e) {
      e.preventDefault();
    },
    markRecaptchaAsVerified(response) {
      this.pleaseTickRecaptchaMessage = '';
      this.captchatMarck = true;
    }
  }
};
</script>
<style lang="scss">
#javascriptComponents {
  .modal-buttons,
  .popover-buttons,
  .tooltip-buttons {
    .btn + .btn {
      margin-left: 3px;
    }
  }
}
.row-height{
  height: 450px;
}
.email-input{
  width: 60%;
  padding: 5px;
  background-color: white;
  margin: 10px;
  border: 1px;
  border-bottom: 2px solid #ECECEC;
}
.password-input{
  width: 60%;
  padding: 5px;
  background-color: white;
  margin: 10px;
  border: 1px;
  border-bottom: 2px solid #ECECEC;
}
.input-button{
  width: 35%;
  height: 50px;
  color: white;
  font-size: 17px;
  font-weight: bold;
  background-color: #00bbff;
  border-radius: 21px 21px 21px 21px;
  -moz-border-radius: 21px 21px 21px 21px;
  -webkit-border-radius: 21px 21px 21px 21px;
  border: 2px solid #ffffff;
}
.f-password{
  text-align: right;
  font-size: 80%;
}
.has-danger{
  width: 60%;
  padding: 5px;
  background-color: white;
  margin: 10px;
  border: 1px;
  border-bottom: 2px solid #FF6E6E;
}
.correct2{
  border-bottom: 2px solid #00FF00;
}
.correct{
  width: 60%;
  padding: 5px;
  background-color: white;
  margin: 10px;
  border: 1px;
  border-bottom: 2px solid #004DFF;
}
.title-input{
  color: #00bbff;
  font-weight: normal;
}
.name-input{
  width: 100%;
  background-color: white;
  font-size: 15px;
  border: 1px;
  border-bottom: 2px solid #ECECEC;
}
.bd-select{
  margin: 15px 0px 0px 4px;
  width: 65px;
  height: 30px;
  font-size: 14px;
  border-radius: 21px 21px 21px 21px;
  -moz-border-radius: 21px 21px 21px 21px;
  -webkit-border-radius: 21px 21px 21px 21px;
  border: 2px solid #ECECEC;
}
.sexo-input{
  width: 100%;
  height: 30px;
  border-radius: 21px 21px 21px 21px;
  -moz-border-radius: 21px 21px 21px 21px;
  -webkit-border-radius: 21px 21px 21px 21px;
  border: 2px solid #ECECEC;
}
.error{
  border-bottom: 2px solid #FF6E6E;
}
.captchat{
  background-color: red;
  height: 60px;
  color: #ffffff;
}
.new-input{
  width: 100%;
  padding: 5px;
  background-color: white;
  margin: 10px;
  border: 1px;
  border-bottom: 2px solid #ECECEC;
}
.check-in-button{
  width: 100%;
  border: 0px;
}

.recover-password-button{
  background-color: #ffffff00;
  color: #FF6E6E;
  border: 0px;
}

@media screen and (min-width: 321px) and (max-width: 768px) { 
  .input-button{
  font-size: 15px;
  }
}
</style>

